import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, OperatorFunction } from 'rxjs';

import { UrlService } from 'app/core/http/url.service';
import { AdminDistrictCalendar } from '../../admin/services/districts-data/models/admin-district-calendars.model';
import { ErrorResult } from '../../admin/services/models/error-result.model';

@Injectable({
  providedIn: 'root'
})
export class DistrictCalendarService {
  public constructor(
    private http: HttpClient,
    private urlService: UrlService) {}

  public getAllCalendars(): Observable<AdminDistrictCalendar[]> {
    const url: string = this.urlService.buildServerApiUrl('admin', 'calendars/getAllCalendars');
    return this.http.get<AdminDistrictCalendar[]>(url);
  }

  public addNewCalendar(calendarId: string, month: string, day: string): Observable<undefined | ErrorResult> {
    const url: string = this.urlService.buildServerApiUrl('admin', 'calendars/addNewCalendar', calendarId, month, day);
    return this.http.post<undefined>(url, {}).pipe(this.handleError());
  }

  private handleError(): OperatorFunction<undefined, ErrorResult | undefined> {
    return catchError((error: HttpErrorResponse) => {
      if (error.status === 400) {
        return of(error.error as ErrorResult);
      }

      throw new Error(error.message);
    });
  }
}
